// Validation de l'email avec regex
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

// Validation du mot de passe avec regex global
export const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-+!*$@%_])([-+!*$@%_\w]{0,999})$/;
    return passwordRegex.test(password);
};

// Validation d'au moins une majuscule dans mot de passe avec regex
export const checkCapital = (password) => {
    const passwordRegex = /^(?=.*[A-Z]).*$/;
    return passwordRegex.test(password);
};

// Validation d'au moins une minuscule dans mot de passe avec regex
export const checkLowercase = (password) => {
    const passwordRegex = /^(?=.*[a-z]).*$/;
    return passwordRegex.test(password);
};

// Validation d'au moins un chiffre dans mot de passe avec regex
export const checkDigit = (password) => {
    const passwordRegex = /^(?=.*\d).*$/;
    return passwordRegex.test(password);
};

// Validation d'au moins un caractère spécial dans mot de passe avec regex
export const checkSpecialCharacter = (password) => {
    const passwordRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>]).*$/;
    return passwordRegex.test(password);
};

// Validation du prénom, du nom et du pseudo avec regex
export const validateName = (name) => {
    const nameRegex = /^[\p{L} -]+$/u;
    return nameRegex.test(name);
};

// Validation du nom composé (ex: prénom et nom dans le mêm champ et donc avec un espace) avec regex
export const validateComposedName = (name) => {
    const nameRegex = /^[\p{L} -]+$/u;
    return nameRegex.test(name);
};

// Validation du téléphone avec regex
export const validatePhone = (phone) => {
    // Format français: +33 6 12 34 56 78 ou 06 12 34 56 78
    const phoneRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
    return phoneRegex.test(phone);
};

// Validation du code postal avec regex
export const validateZipcode = (zipcode) => {
    // Format français: 5 chiffres
    const zipcodeRegex = /^\d{5}$/;
    return zipcodeRegex.test(zipcode);
};

// Validation des champs
export const validateField = (name, value) => {
    switch (name) {
        case 'email':
            if (!value) {
                return 'L\'email est requis';
            }
            if (!validateEmail(value)) {
                return 'Format d\'email invalide';
            }
            if (value.length < 6) {
                return 'L\'email doit comporter au minimum 6 caractères';
            }
            if (value.length > 255) {
                return 'L\'email doit comporter au maximum 255 caractères';
            }
            return '';

        case 'password':
            if (!value) {
                return 'Le mot de passe est requis';
            }
            if (value.length < 8) {
                return 'Le mot de passe doit contenir au moins 8 caractères';
            }
            if (value.length > 20) {
                return 'Le mot de passe doit comporter au maximum 20 caractères';
            }
            return '';

        case 'actualPassword':
            if (!value) {
                return 'Le mot de passe actuel est requis';
            }
            break;

        case 'newPassword':
            if (value === '') {
                return 'Le nouveau mot de passe est requis';
            }
            if (!validatePassword(value)) {
                return 'Le mot de passe doit contenir au moins 1 chiffre, 1 lettre minuscule, 1 lettre majuscule, 1 caractère spécial et ne doit contenir aucun espace';                
            }
            if (value.length < 8) {
                return 'Le mot de passe doit comporter au minimum 8 caractères';
            }
            if (value.length > 20) {
                return 'Le mot de passe doit comporter au maximum 20 caractères';
            }
            break;

        case 'confirmPassword':
            if (!value) {
                return 'La confirmation du mot de passe est requise';
            }
            return '';
        
        case 'firstname':
            if (!value || value.length < 2) {
                return 'Le prénom doit faire au moins 2 caractères';
            }
            if (value.length > 50) {
                return 'Le prénom ne peut pas dépasser 50 caractères';
            }
            if (!validateName(value)) {
                return 'Le prénom ne doit pas comporter de caractères spéciaux';
            }
            break;
            
        case 'lastname':
            if (!value || value.length < 2) {
                return 'Le nom doit faire au moins 2 caractères';
            }
            if (value.length > 50) {
                return 'Le nom ne peut pas dépasser 50 caractères';
            }
            if (!validateName(value)) {
                return 'Le nom ne doit pas comporter de caractères spéciaux';
            }
            break;

        case 'phone':
            if (!value) {
                return 'Le numéro de téléphone est requis';
            }
            if (!validatePhone(value)) {
                return 'Format de téléphone invalide';
            }
            // Enlever les espaces pour vérifier la longueur
            const cleanPhone = value.replace(/\s+/g, '');
            if (cleanPhone.length < 10) {
                return 'Le numéro doit comporter au minimum 10 chiffres';
            }
            if (cleanPhone.length > 16) {
                return 'Le numéro doit comporter au maximum 16 chiffres';
            }
            return '';

        case 'zipcode':
            if (!value) {
                return 'Le code postal est requis';
            }
            if (!validateZipcode(value)) {
                return 'Le code postal doit contenir exactement 5 chiffres';
            }
            return '';

        case 'username':
            if (!value || value.length < 2) {
                return 'Le pseudo doit comporter au moins 2 caractères';
            }
            if (value.length > 50) {
                return 'Le pseudo ne peut pas dépasser 50 caractères';
            }
            if (!validateName(value)) {
                return 'Le pseudo ne doit pas comporter de caractères spéciaux';
            }
            break;

        case 'name':
            if (!value || value.length < 2) {
                return 'Le nom doit comporter au moins 2 caractères';
            }
            if (value.length > 50) {
                return 'Le nom ne peut pas dépasser 50 caractères';
            }
            if (!validateComposedName(value)) {
                return 'Le nom ne doit pas comporter de caractères spéciaux';
            }
            break;

        case 'message':
            if (!value) {
                return 'Le message est requis';
            }
            break;

        default:
            return '';
    }
};